// extracted by mini-css-extract-plugin
export var button = "_or-0";